import React from "react";

const RHFErrorMessage = ({ errors, name }) => {
  if (typeof name === "string") {
    if (name && errors && errors[name] && errors[name].message)
      return <span style={{ color: "red" }}>{errors[name].message}</span>;
  }

  if (Array.isArray(name)) {
    for (let i = 0; i < name.length; i++) {
      if (name[i] && errors && errors[name[i]] && errors[name[i]].message)
        return <span style={{ color: "red" }}>{errors[name[i]].message}</span>;
    }
  }

  return null;
};

export default RHFErrorMessage;
